import React from 'react';
import { DatePicker, Form, Input, Select } from 'antd';
import { TableCell } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import dayjs from 'dayjs';

const TableCellRenderer = ({ field, columnConfig, constantFormValues, form, index, screen, rowIndex, handleInputMonthChange }) => {
	const renderComponent = () => {
		const { component } = columnConfig;
		const key = columnConfig.key;

		if (key === 'inputChangeEffectiveDate') {
			// console.log(`TableCellRenderer: Row ${index}, EffectiveDate, Received props.disabled: ${component.props.disabled}`);
		}

		// Get color for comparison-based fields
		const getColor = () => {
			if (index === 0 || !form) return 'black';

			const currentValue = form.getFieldValue(['changes', index, key]);
			const previousValue = form.getFieldValue(['changes', index - 1, key]);

			return currentValue === previousValue ? 'black' : 'blue';
		};

		// Determine if the field should be disabled
		const isDisabled = () => {
			// Retirement term is always disabled (calculated field)
			if (key === 'inputChangeRetirementTerm') {
				return true;
			}

			// First row discount rate is disabled (uses initial value)
			if (index === 0 && key === 'inputChangeDiscountRate') {
				return true;
			}

			if (key === 'inputChangeRetirementDate') {
				return true;
			}

			if (key === 'inputChangeRetirementCost') {
				return true;
			}

			// General screen-based rules
			if (screen === 'VIEW') return true;
			if (screen !== 'CREATE' && index < rowIndex) return true;

			return false;
		};

		// Adjust style for color indication
		const getStyle = () => {
			const baseStyle = { ...component.props.style };

			// Apply color changes for comparison fields
			if (['inputChangeRetirementTerm', 'inputChangeDiscountRate', 'inputChangeRetirementCost'].includes(key)) {
				baseStyle.color = getColor();
			}

			return baseStyle;
		};

		switch (component.type) {
			case 'datePicker':
				return (
					<DatePicker
						{...component.props}
						style={component.props.style}
						disabled={typeof component.props.disabled === 'boolean' ? component.props.disabled : isDisabled()}
						onChange={(date) => handleInputMonthChange?.(date, index)}
						disabledDate={(current) => {
							if (!form || !current) return false;
							const retirementStartDate = form.getFieldValue('retirementStartDate');
							return retirementStartDate && current.isAfter(dayjs(retirementStartDate), 'day');
						}}
					/>
				);

			case 'input':
				return (
					<Input
						{...component.props}
						style={getStyle()}
						disabled={typeof component.props.disabled === 'boolean' ? component.props.disabled : isDisabled()}
					/>
				);

			case 'numericFormat':
				return (
					<NumericFormat
						{...component.props}
						style={getStyle()}
						customInput={Input}
						disabled={typeof component.props.disabled === 'boolean' ? component.props.disabled : isDisabled()}
					/>
				);

			case 'select':
				// eslint-disable-next-line no-case-declarations
				const options = constantFormValues?.changes?.changeList[key]?.options || [];
				return (
					<Select
						{...component.props}
						options={options}
						disabled={typeof component.props.disabled === 'boolean' ? component.props.disabled : isDisabled()}
					>
						{options.map(({ key: optionKey, value, label }) => (
							<Select.Option key={optionKey} value={value}>
								{label}
							</Select.Option>
						))}
					</Select>
				);

			default:
				return null;
		}
	};

	const rules = constantFormValues?.changes?.changeList[columnConfig.key]?.rules || [];

	return (
		<TableCell
			align={['inputChangeDiscountRate', 'inputChangeRetirementCost'].includes(columnConfig.key) ? 'center' : undefined}
			style={{ position: 'relative' }}
		>
			<Form.Item style={{ margin: 0 }} name={[field.name, columnConfig.key]} rules={rules}>
				{renderComponent()}
			</Form.Item>
		</TableCell>
	);
};

export default React.memo(TableCellRenderer);
